webix.protoUI({
	name: "ssheet-borders-suggest",
	defaults:{
		width: 300
	},
	$init: function(config){
		const skin = webix.skin.$name;
		config.body = {
			rows:[
				{
					cols:[
						{ view: "ssheet-icons", scroll: false, select: true,
							xCount: 4,
							yCount: 2,
							tooltip: { template: obj => obj.tooltip },
							template: function(obj){
								const css = "webix_ssheet_button_icon webix_ssheet_icon ssi-borders-" + obj.id;
								return `<span class='${css}'></span>`;
							},
							data: config.data
						},
						{
							rows:[
								{ 
									view: "ssheet-color", 
									height: 0,
									css: config.css, 
									name: config.name, 
									width: 68,
									value: (skin == "contrast" || skin == "dark") ? "#ffffff" : "#000000",
									tooltip: webix.i18n.spreadsheet.tooltips["borders-color"],
									title: "<span class='webix_icon wxi-pencil'></span>",
								},
								{
									view: "richselect",
									height: 0,
									css:"webix_ssheet_border_type", 
									value:"thin", 
									tooltip: webix.i18n.spreadsheet.tooltips["borders-line"],
									suggest:{
										fitMaster:false,
										width:130,
										css: "webix_ssheet_suggest",
										body: {
											template:"<div class='webix_ssheet_border webix_ssheet_border_#id#'></div>",
										},
										data:[
											{ id: "hair" },
											{ id: "dotted" },
											{ id: "dashDotDot" },
											{ id: "dashDot" },
											{ id: "dashed" },
											{ id: "thin" },
											{ id: "mediumDashDotDot" },
											{ id: "slantDashDot" },
											{ id: "mediumDashDot" },
											{ id: "mediumDashed" },
											{ id: "medium" },
											{ id: "thick" },
											{ id: "double" }
										]
									}
								}
							]
						}
					]
				},
				{
					view: "button",
					css: "webix_ssheet_border_apply",
					label: webix.i18n.spreadsheet.labels.apply,
					click: ()=> this.updateMasterValue()
				}
			]
		};
		this.attachEvent("onHide", ()=> this.getPositionView().unselect());
	},
	updateMasterValue: function(){
		const value = this.getValue();
		const master = webix.$$(this.config.master);
		master.setValue(value, "user");
		this.hide();
	},
	setValue: function(value){
		if(value[0])
			this.getPositionView().select(value[0]);
		if(value[1])
			this.getColorView().setValue(value[1]);
		if(value[2])
			this.getTypeView().setValue(value[2]);
	},
	getValue: function(){
		return [this.getPositionView().getSelectedId(), this.getColorView().getValue()||"", this.getTypeView().getValue()||""];
	},
	getPositionView: function(){
		return this.queryView("ssheet-icons");
	},
	getColorView: function(){
		return this.queryView("ssheet-color");
	},
	getTypeView: function(){
		return this.queryView("richselect");
	},
	getItemText:function(){
		return "<span class='webix_ssheet_button_icon webix_ssheet_icon ssi-borders-all'>";
	},
	getSuggestion: function(){}
},webix.ui.suggest);

webix.protoUI({
	name: "ssheet-borders",
	$cssName: "richselect",
	$init: function(config){
		config.options = {
			view: "ssheet-borders-suggest",
			fitMaster: false,
			data: config.data
		};

		this.$ready.push(webix.bind(function(){
			this.getPopup().config.master = this.config.id;
		},this));

	},
	setValue: function(value, config){
		if(webix.isArray(value)){
			if(!this.config.value || value[0] !=  this.config.value[0] || value[1] !=  this.config.value[1]){
				this.getPopup().setValue(value);
			}
			const old = this.config.value;
			this.config.value = value;
			if (value[0])
				this.callEvent("onChange", [this.getValue(), old, config]);
		}
		return value;
	},
	getValue: function(){
		return  this.getPopup().getValue().join(",");
	},
	getList: function(){
		return this.getPopup().getBody().getChildViews()[0];
	},
	getColorView: function(){
		return this.getPopup().getBody().getChildViews()[1].getChildViews()[0];
	}
},webix.ui.richselect);